import React from "react";

interface TopRatedExperienceProps {
  rating: number;
  totalReviews: number;
  isHovered: boolean;
}

const TopRatedExperience: React.FC<TopRatedExperienceProps> = ({
  rating,
  totalReviews,
  isHovered,
}) => {
  if (rating < 4.5 || totalReviews < 3000) return null;

  return (
    <div
      className={`absolute -bottom-1 right-2 transition-all duration-[450] ease-in-out w-7 h-7 ring-[1.5px] ring-yellow-400 whitespace-nowrap bg-white rounded-full shadow-md z-10 flex items-center group overflow-hidden hover:cursor-default ${
        isHovered ? "w-[67%]" : "justify-center"
      }`}
    >
      <i
        className={`fa-solid fa-stars text-yellow-400 text-[15px] ${
          isHovered ? "pl-4" : ""
        }`}
      ></i>
      <span
        className={`w-full text-center text-[12px] font-medium text-neutral-900 ${
          isHovered ? "" : "hidden"
        }`}
      >
        Top Rated Experience
      </span>
    </div>
  );
};

export default TopRatedExperience;
